import React, { useEffect, useRef, useState } from 'react';
import { interpolate } from 'd3';

const DEIPageCounter = ({ value }) => {
  const rafTimeRef = useRef();
  const rafRef = useRef();

  const [currentValue, setCurrentValue] = useState(0);
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const _value = Number(value);

    if (_value === currentValue) return;

    const interpolator = interpolate(_value, currentValue);
    const duration = 150;

    const animate = time => {
      // If the animation's start time has been stashed, do the animation
      // otherwise, stash the start time
      if (rafTimeRef.current !== undefined) {
        const timeElapsed = time - rafTimeRef.current;

        // If time elapsed is longer than the intended duration, reset the start time,
        // set the canonical data, and break the animation loop
        if (timeElapsed > duration) {
          rafTimeRef.current = undefined;
          setDisplayValue(_value);
          setCurrentValue(_value);
          return;
        }

        // Set the animated data using the startAngle and endAngle interpolators
        setDisplayValue(Math.round(interpolator(timeElapsed / duration)));

      } else {
        // Stash the start time
        rafTimeRef.current = time;
      }

      // Continue the animation loop
      rafRef.current = window.requestAnimationFrame(animate);
    }

    // Start the animation loop
    rafRef.current = window.requestAnimationFrame(animate);

    // Reset and clear when something changes
    return () => {
      rafTimeRef.current = undefined;
      setCurrentValue(_value);
      setDisplayValue(_value);
      window.cancelAnimationFrame(rafRef.current);
    }
  }, [currentValue, value]);

  return (
    <span>{displayValue}</span>
  );
}

export default DEIPageCounter;
